import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthKeycloakGuard } from './_auth/keycloack-auth.guard';
import { RolesConfigResolverService } from './_helpers/roles-config-resolver.service';

export const routes: Routes = [
    {
        path: '',
        loadChildren: () =>
            import('./_modules/home/home.module').then((m) => m.HomeModule),
    },
    {
        path: 'glance',
        loadChildren: () =>
            import('./_modules/glance/glance.module').then(
                (m) => m.GlanceModule
            ),
    },
    {
        path: 'resources',
        loadChildren: () =>
            import('./_modules/resources/resources.module').then(
                (m) => m.ResourcesModule
            ),
    },
    {
        path: 'main',
        loadChildren: () =>
            import('./_modules/main/main.module').then((m) => m.MainModule),
        canActivate: [AuthKeycloakGuard],
        resolve: { userInfo: RolesConfigResolverService },
        data: { allowedRoles: ['all'] },
    },
    {
        path: '**',
        redirectTo: '',
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
